import React, { PureComponent } from 'react'
import packageJson from '../../../package.json'
import axios from 'axios'
import { URIS } from '../../Uris'
import { ToastContainer, ToastStore } from 'react-toasts'

class Version extends PureComponent {
  componentDidMount () {
    axios({
      method: 'GET',
      url: URIS.version,
      headers: URIS.axiosHeaders
    }).then(res => {
      const lastVersion = res.data.data
      const loadedVersion = packageJson.version
      if (parseInt(res.data.data.replace(/[.]/g, ''), 10) > parseInt(packageJson.version.replace(/[.]/g, ''), 10)) {
        console.log(loadedVersion, '->', lastVersion, 'New version available')
        ToastStore.success(
          'Nuovo aggiornamento disponibile (' + lastVersion + ')\nRicaricare la pagina',
          5000)
      }
    })
  }
  render () {
    return (
      <div>
        <ToastContainer store={ToastStore} />
      </div>
    )
  }
}

export default Version



// WEBPACK FOOTER //
// ./src/components/Bone/Version.js